import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertWhatIf = () => {
    const filters = [
        {
            name: "Asset",
            type: "dropdown",
            options: ["HVAC", "Thermostat", "Water Heater", "Gas Meter", "Water Meter", "Electric Panel"],
        },
        {
            name: "Doing Nothing",
            type: "button",
        },
        {
            name: "Repair or Replace",
            type: "button",
        },
        {
            name: "Degradation",
            type: "button",
        },
        {
            name: "Total Cost",
            type: "button",
        },
    ];

    return (
        <AnalysisPage title="What If" filters={filters}></AnalysisPage>
    )
};

export default AlertWhatIf;
